import React from 'react';
import { DNABox, DNASlider, Iffy } from '@alucio/lux-ui/src';
import { HubORM } from 'src/types/orms';
import { useHubsState } from 'src/state/context/Hubs/HubsStateProvider';
import { HubsStateProvider } from 'src/state/context/Hubs/HubsStateProvider.proxy';
import HubRHFormStateProvider from './useHubRHFormStateProvider';

// COMPORNTN
import Header from 'src/screens/Hubs/EditHub/Header';
import LeftSideBar from 'src/screens/Hubs/EditHub/LeftSideBar';
import Content from 'src/screens/Hubs/EditHub/Content';
import RightSideBar from 'src/screens/Hubs/EditHub/RightSideBar';
import { HubType } from '@alucio/aws-beacon-amplify/src/models';

interface EditHubProps {
  hubORM: HubORM
}

const EditHub: React.FC<EditHubProps> = ({ hubORM }) => {
  const hubId = hubORM.model.id

  return (
    <HubRHFormStateProvider hubId={hubId}>
      <DNABox fill appearance="col">
        <Header hubORM={hubORM}/>
        <DNABox fill>
          <Iffy is={hubORM.model.hubType !== HubType.TEMPLATE_INSTANCE}>
            <LeftSideBar/>
          </Iffy>
          <Content/>
          {/* since templates are shared differently (via shared modal), we dont need the right side bar */}
          {/* this is used for standalone and template instances */}
          <Iffy is={hubORM.model.hubType !== HubType.TEMPLATE}>
            <RightSideBar hubORM={hubORM}/>
          </Iffy>
        </DNABox>
      </DNABox>
    </HubRHFormStateProvider>
  )
}

const EditHubWrapper: React.FC = () => {
  const hubState = useHubsState()
  const { hubORM, onInvisibleCallback, editHubSliderVisible, setEditHubSliderVisible } = hubState

  if (!hubORM) return null
  return (
    <DNASlider
      visible={editHubSliderVisible}
      setVisible={setEditHubSliderVisible}
      orientation="horizontal"
      onInvisible={() => {
        if (typeof onInvisibleCallback.current === 'function') {
          onInvisibleCallback.current?.()
        }
      }}
    >
      <HubsStateProvider value={hubState}>
        <EditHub hubORM={hubORM} />
      </HubsStateProvider>
    </DNASlider>
  )
}

export default EditHubWrapper
